import { Event } from './event';
import { InputBatch } from '@/models/input-batch';

export class InputBatchReviewStartedEvent extends Event<InputBatch> {}
